import React from 'react';
import { useThemeContext } from '../../contexts';

type IconProps = {
  iconWidth?: number;
  iconHeight?: number;
};

/**
 * CardSlashIcon is a component that displays a card slash icon.
 *
 * @param {IconProps} props
 * @return {React.FC}
 */
const CardSlashIcon: React.FC<IconProps> = (props) => {
  const { theme } = useThemeContext();
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      width={props.iconWidth}
      height={props.iconHeight}
      style={{ verticalAlign: 'bottom' }}
      xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          d="M2 8.5H15.24"
          stroke={theme.primary}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M6 16.5H7.29"
          stroke={theme.primary}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M11 16.5H14.5"
          stroke={theme.secondary}
          strokeWidth="1.5"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M7.98047 20.5001H17.5605C21.1205 20.5001 22.0005 19.6201 22.0005 16.1101V6.89014"
          stroke={theme.secondary}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M19.99 3.75C19.37 3.57 18.57 3.5 17.56 3.5H6.44C2.89 3.5 2 4.38 2 7.89V16.1C2 18.44 2.39 19.61 3.71 20.13"
          stroke={theme.primary}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
        <path
          d="M22 2L2 22"
          stroke={theme.primary}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"></path>{' '}
      </g>
    </svg>
  );
};

export default CardSlashIcon;
